import { ArrowDownRight, ArrowUpRight, Minus } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";
import { Sparkline } from "./Sparkline";
import { usd, signed, tone, TONE } from "./utils";

const FRAMES = [
  { n: 1, label: "1 min", hint: "vs. 1 minute ago — the quickest, noisiest signal" },
  { n: 5, label: "5 min", hint: "vs. 5 minutes ago — short-term direction" },
  { n: 15, label: "15 min", hint: "vs. 15 minutes ago — the bigger picture" },
];

const Chip = ({ btc, f }) => {
  const ch = btc[`change_${f.n}m`], pct = btc[`pct_${f.n}m`], t = tone(ch);
  const Icon = t === "up" ? ArrowUpRight : t === "down" ? ArrowDownRight : Minus;
  return (
    <div className={`rounded-lg border p-3 ${TONE[t]}`} data-testid={`change-${f.n}m`}>
      <div className="flex items-center justify-between">
        <span className="text-[10px] uppercase tracking-widest font-num opacity-80">{f.label}</span>
        <Icon className="w-4 h-4" />
      </div>
      <div className="font-num font-bold text-base sm:text-lg mt-1" data-testid={`change-${f.n}m-pct`}>{signed(pct, 3)}%</div>
      <div className="font-num text-xs opacity-80">{ch > 0 ? "+" : ""}{usd(ch)}</div>
      <p className="text-[11px] text-slate-400 mt-2 leading-snug">{f.hint}</p>
    </div>
  );
};

export const BtcCard = ({ btc }) => (
  <section className="card p-5 sm:p-6 fade-up h-full" data-testid="btc-card">
    <div className="text-xs uppercase tracking-widest font-num text-slate-400">Bitcoin price (live, USD)</div>
    {btc ? (
      <>
        <div className="font-num font-bold text-4xl sm:text-5xl tracking-tight mt-2" data-testid="btc-price">{usd(btc.price)}</div>
        <div className="text-xs text-slate-500 mt-1" data-testid="btc-updated">
          Updated {new Date(btc.timestamp).toLocaleTimeString()}
        </div>
        <Sparkline points={btc.sparkline} up={btc.change_15m >= 0} />
        <div className="grid grid-cols-3 gap-2 sm:gap-3 mt-2">
          {FRAMES.map((f) => <Chip key={f.n} btc={btc} f={f} />)}
        </div>
        <p className="text-xs text-slate-400 mt-4 leading-relaxed">
          <span className="text-slate-200 font-semibold">How to read this:</span> each box shows how much the price moved
          compared to that many minutes ago. Green = price went up, red = price went down. The line above is the last 15 minutes.
        </p>
      </>
    ) : (
      <div className="space-y-3 mt-3"><Skeleton className="h-12 w-2/3 bg-[#1A1D2B]" /><Skeleton className="h-24 bg-[#1A1D2B]" /></div>
    )}
  </section>
);
